import React, { useState, useRef, useEffect } from "react";
import { IconButton, Typography } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import Grid from "@mui/material/Grid2";
import { Link } from "react-router-dom";
import Footer from "../../Footer/Footer";
import Header from "../../Header/MegaMenu";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import "owl.carousel"; // Import Owl Carousel AFTER jQuery
import OwlCarousel from "react-owl-carousel";
import '../outterpages.css'
// import curreciesBan from '../../../assets/Images/Outterpage/currencies-banner-img.webp';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled } from "@mui/material/styles";
import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';
import Stack from '@mui/material/Stack';
import eng from '../../../assets/Images/Outterpage/eng.webp'
import jap from '../../../assets/Images/Outterpage/jap.webp'
import cardimg from '../../../assets/Images/Outterpage/card-1.webp'
import sec4 from '../../../assets/Images/Outterpage/sec-4-img.webp'
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import commoditiesban from '../../../assets/Images/Outterpage/commodities-banner.webp'
import commoditiescta from '../../../assets/Images/Outterpage/cta-commodites.webp'
import pambanner from '../../../assets/Images/Outterpage/pam-banner.webp'
import { useScroll, useTransform, motion, useInView } from 'framer-motion'
import imgcrn from '../../../assets/Images/Outterpage/img-crn.webp'

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    borderBottom: "1px solid  rgba(255, 146, 71, 1)  ",
    '&:nth-of-type(odd)': {
        background: "linear-gradient(90deg,rgba(99, 97, 97, 0.44) 15.1%,rgba(70, 69, 68, 0.49) 85.42%)",
    },
    // Hide the last border of the table
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

// const videos = [
//   { id: 1, src: video1 },
//   { id: 2, src: video2 },
//   { id: 3, src: video3 },
//   { id: 3, src: video4 },
// ];
const testimonials = [
    {
        name: "Sherly",
        position: "CEO",
        text: "Figma ipsum component variant main layer. Library figjam subtract font rotate move auto. Figjam strikethrough bullet text device pen scale. Group horizontal link library flows ellipse flatten library undo.",
    },
    {
        name: "Carlos",
        position: "Product Manager",
        text: "An amazing experience! The support and innovation mindset Rishi brings to the team makes every project more exciting and successful.",
    },
    // {
    //   name: "Rishi",
    //   position: "CEO",
    //   text: "Regulus has truly streamlined my trading activity. The platform is incredibly user-friendly, making it easy to navigate and execute trades quickly. I've seen a noticeable improvement in my efficiency!",
    // },
];

const options = {
    margin: 50,
    items: 1,
    autoplay: true,
    autoplayTimeout: 6000,
    dots: false, // Hide default dots
    loop: true,
    smartSpeed: 800,
    nav: true, // We will use custom navigation
    responsive: {
        0: {
            dots: true,
            nav: false,
        },
        768: {
            dots: false,
            nav: true,
        },
    },
};

const marketData = [
    { id: 1, pair: "GBP/USD", value: "1,355.78", trend: "up" },
    { id: 2, pair: "GBP/USD", value: "1,120.65", trend: "down" },
    { id: 3, pair: "GBP/USD", value: "1,120.65", trend: "down" },
    { id: 4, pair: "GBP/USD", value: "1,355.78", trend: "up" },
    { id: 5, pair: "GBP/USD", value: "1,120.65", trend: "down" },
];


const tableData = [
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },
    {
        name: "USDJPY",
        speed: "83.4",
        comission: "$0",
        margin: "0.34%,",
        longswap: "-44",
        shortswap: "-44",
        stoplevel: "0",

    },

]
const accordianData = [
    {
        question: "Is there a minimum investment required for a Finowiz PAMM account?",
        answer: "Yes, Finowiz PAMM accounts have minimum investment requirements. For money managers, the minimum fee to open an account is USD 500, while for investors, the minimum initial deposit is USD 50. These amounts are necessary to start and access the PAMM portal.",

        panel: "panel1"
    },
    {
        question: "Can investors choose their preferred money managers in Finowiz PAMM?",
        answer: "Yes, copy trading can be advantageous for beginners by enabling them to learn from expert strategies and potentially earn while gaining market insights. However, it's important to understand the associated risks.",

        panel: "panel2"
    },
    {
        question: "Are there any fees associated with Finowiz PAMM accounts?",
        answer: "Yes, Finowiz PAMM accounts may involve fees. Money managers can establish flexible fee structures, often referred to as `offers ,` which outline the charges for their services. Investors should review these fee structures when selecting a money manager to understand any associated costs.",

        panel: "panel3"
    },

]
const cardset = [
    {

        head: "Accessibility and Convenience",
        para: "The PAMM system provides a user-friendly, web-based interface accessible from any device with a standard web browser, eliminating the need to install MT4."
    },
    {

        head: "For Traders",
        para: "Maximize profits, establish a certified track record, and potentially transition into professional fund management."
    },
    {

        head: "For Investors",
        para: "Gain access to top-performing trading strategies shared by experienced traders while maintaining control over your accounts."
    },
    {

        head: "Flexibility and Control",
        para: "Investors can quickly join or exit a PAMM account, usually within a few business hours. The hourly NAV calculation ensures transparent profit/loss allocation for all trades."
    },
    {

        head: "Customization",
        para: "Investors independently choose which PAMM accounts to join, while managers can create flexible fee structures."
    },
    {

        head: "Security",
        para: "The system protects managers' strategic intellectual property, safeguarding it from potential reverse engineering by investors."
    },

]

const PAMM = () => {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const lg = useMediaQuery(theme.breakpoints.up("lg"));
    const md900 = useMediaQuery(theme.breakpoints.up("900"));
    const xl = useMediaQuery(theme.breakpoints.up("xl"));
    const md766 = useMediaQuery(theme.breakpoints.up("766"));
    const [expanded, setExpanded] = React.useState('panel1');
    const lg1200 = useMediaQuery(theme.breakpoints.up("1200"));

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

        // Create separate refs
        const refA = useRef(null);
        const refB = useRef(null);
        const refC = useRef(null);
        const refD = useRef(null);
    
        // Use useInView for each
        const isInViewA = useInView(refA, { once: false });
        const isInViewB = useInView(refB, { once: false });
        const isInViewC = useInView(refC, { once: false });
        const isInViewD = useInView(refD, { once: false });
        
    return (
        <div className="OutterPage">
            <Header />
            <div className="bg-outer comm-ot-bg">
                <section className="banner outter-banner">
                    <div className="contain-width">
                        <Grid container sx={{ alignItems: "flexStart" }}>
                            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }} sx={{ placeContent: "center" }}>
                                <div
                                    className="banner-left "
                                    style={{ height: xl ? "500px" : "auto", placeContent: "center" }}
                                >
                                    <p>PAMM</p>
                                    <h1 className="mb-30 mt-10">
                                        Finowiz <span>PAMM</span>
                                    </h1>
                                    <p>Optimize your investments with our PAMM trading platform, guided by expert traders.</p>
                                    {/* <div
                  className="display-1 btn flex-wrap "
                  style={{ marginBottom: matches ? "40px" : "20px" }}
                >
                  <Link to="/open-new-account" className="bg-btn">
                    Get Started
                  </Link>
                </div> */}
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>

                                <div className="text-center ">
                                    <img width="90%" src={pambanner} />
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </section>
                <section className="trade-easy sec-3 ">
                    <div className="contain-width">
                        <div className="heading ">
                            {/* <p>
                                <span>Why Finowiz</span>
                            </p> */}
                            <h2>
                                What is <span>PAMM?</span>
                            </h2>
                            <p >We’re proud of our status as a global online trading company, and we won’t rest until we can give every one of our traders the ultimate trading experience.</p>
                        </div>
                        <Grid container spacing={5} className="pamm-sec" sx={{ justifyContent: "center", marginTop: "50px" }}>
                            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 5, xl: 5 }} className="pamm-card">
                                <h3>For Starters (New Traders)</h3>
                                <p>If you're new to trading and seeking opportunities to grow, our PAMM solution is perfect for you. As an investor, you can allocate funds to experienced traders and benefit from their expertise under a consolidated account.</p>
                                <p className="mt-20">You’ll earn proportional returns based on the master trader’s success, giving you a chance to learn and grow while your investments work for you</p>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 5, xl: 5 }} className="pamm-card">
                                <h3>For Masters (Experienced Traders)</h3>
                                <p>If you have a proven trading strategy and are looking for additional earnings, consider becoming a master in our PAMM solution. As a master, you can trade on behalf of multiple investors under a consolidated account.</p>
                                <p className="mt-20">You'll earn an additional percentage from each investor's account, increasing your income based on successful trades.</p>
                            </Grid>
                        </Grid>

                    </div>
                </section>
                <section className="trade-open  pamm-cta " style={{}}>
                    <div className="contain-width">
                        <Grid container spacing={8} sx={{ rowGap: 0, }}>
                            <Grid
                                item
                                size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}
                                className="left-side"
                                sx={{ placeItems: !md766 && "center", textAlign: !md766 && "center" }}
                            >
                                <h3>
                                    Finowiz <span>PAMM </span>
                                </h3>
                                <p>
                                    The Finowiz PAMM, or Percentage Allocation Management Module, is a software tool that allows traders to share their strategies with interested investors. Investors can access their PAMM accounts through a web-based interface, requiring only a standard web browser on any device (mobile or desktop), eliminating the need to install MT4.
                                </p>
                                <div className="mt-40">
                                    <Link to="#" className="bg-btn">
                                        Register now
                                    </Link>
                                </div>
                            </Grid>
                            {/* <Grid
                            item
                            size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}
                            className=""
                        >
                            <div>
                                <img width="100%" src={sec4} />
                            </div>

                        </Grid> */}
                        </Grid>
                    </div>
                </section>
                <section className="trade-easy sec-3">
                    <div className="contain-width">
                        <div className="heading">
                            {/* <p>
                                <span>Why Finowiz</span>
                            </p> */}
                            <h2>
                                PAMM <span>Software</span>
                            </h2>
                            <p>
                                Enjoy exclusive copy trading features with Finowiz for a superior trading experience.
                            </p>
                        </div>
                        <Grid container spacing={5} className="card-set-hv">
                            {
                                cardset.map((item) => (
                                    <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 4 }} className="why-choose-card mt-10" sx={{ alignItems: !md900 && "center" }}>
                                        <div>
                                            <img src={cardimg} />
                                        </div>
                                        <p className="mt-10 head"><span className="grd">{item.head}</span></p>
                                        <p className="mt-10">{item.para}</p>

                                    </Grid>
                                ))
                            }


                        </Grid>


                    </div>
                </section>
            </div>
            <section className="trade-easy sec-3 roadmap-bg2">
                <div className="contain-width">
                    <div className="heading">
                        <p>
                            {/* <span>INSTALL</span> */}
                        </p>
                        <h2>
                            How to Start <span>Copy Trading</span>
                        </h2>
                        <p>Figma ipsum component variant main layer. Prototype share asset stroke distribute star create. Rectangle stroke auto figjam project library select. </p>

                    </div>
                    <Grid container spacing={5} className="cp-tade-roadmap2 " sx={{ justifyContent: "space-between" }}>
                        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }} >

                        </Grid>
                        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 5, xl: 5 }} className="">
                            <motion.div
                                ref={refA}
                                initial={{ opacity: 0, y: 50 }}
                                animate={{ opacity: isInViewA ? 1 : 0, y: isInViewA ? 0 : 50 }}
                                transition={{ duration: 1 }}
                            >
                                {/* <div style={{ height: "100px", backgroundColor: "red" }}>
                                        This fades in when visible and out when not!
                                    </div> */}
                                <span className="crn-alg1">
                                    {
                                        lg1200 && <span className="crn-box1">
                                            <img width="90%" src={imgcrn} />
                                        </span>
                                    }
                                    <div className="txt-content1" style={{ padding: "20px 30px" }}>
                                        <p>Step 1</p>
                                        <p><span className="grd">Sign Up to Finowiz</span></p>
                                        <p>Register with Finowiz by providing your basic personal information and contact details in our registration form. Complete the email verification process by clicking the link sent to your inbox</p>
                                    </div>
                                </span>
                            </motion.div>


                        </Grid>

                        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 5, xl: 5 }} className=" mt-50 ">
                            <motion.div
                                // ref={ref}
                                // style={{
                                //     opacity: isInView ? 1 : 0,
                                //     transition: 'opacity 1s ease-in-out',
                                ref={refB}
                                initial={{ opacity: 0, y: 50 }}
                                animate={{ opacity: isInViewB ? 1 : 0, y: isInViewB ? 0 : 50 }}
                                transition={{ duration: 1 }}
                            >
                                <span className="crn-alg1">
                                    {
                                        lg1200 && <span className="crn-box1">
                                            <img width="90%" src={imgcrn} />
                                        </span>
                                    }
                                    <div className="txt-content1" style={{ padding: "20px 30px", textAlign: "center" }}>
                                        <p>Step 2</p>
                                        <p><span className="grd">Open a Live PAMM Account</span></p>
                                        <p>Start a PAMM account by selecting "OPEN LIVE ACCOUNT" in the portal and choosing PAMM from the dropdown menu.</p>
                                    </div>
                                </span>

                            </motion.div>

                        </Grid>
                        {
                            lg1200 &&
                            <> <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }} >

                            </Grid>
                                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }} >

                                </Grid>
                            </>


                        }

                        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 5, xl: 5 }} className="mt-50">
                            <motion.div
                                ref={refC}
                                initial={{ opacity: 0, y: 50 }}
                                animate={{ opacity: isInViewC ? 1 : 0, y: isInViewC ? 0 : 50 }}
                                transition={{ duration: 1 }}
                            >
                                <span className="crn-alg1">
                                    {
                                        lg1200 && <span className="crn-box1">
                                            <img width="90%" src={imgcrn} />
                                        </span>
                                    }
                                    <div className="txt-content1" style={{ padding: "20px 30px", textAlign: "center" }}>
                                        <p>Step 3</p>
                                        <p><span className="grd">Deposit Funds</span></p>
                                        <p>Add funds to your new PAMM account to gain access to the portal. Money managers need to deposit a minimum of USD 500, while investors require a minimum deposit of USD 50. Your earned returns will also be deposited into this account</p>
                                    </div>
                                </span>
                            </motion.div>

                        </Grid>
                   
                    </Grid>


                </div>
            </section>
          
            <section class="cta-sec2 out-cta">
                <div className="contain-width">
                    <Grid container spacing={8}>
                        <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                            <label>Your Partner in Trading Success</label>
                            <h2 >Register Now for Seamless Trading with Finowiz</h2>
                            {/* <p>
                            Learn to trade without using real money, refining your
                            strategies and learning from mistakes.
                          </p> */}
                            <Link to="#" className="brd-btn" >
                                Register Now
                            </Link>
                        </Grid>
                    </Grid>
                </div>
            </section>



            <Footer />
        </div>
    );
};

export default PAMM;
